<template>
  <ItemActionCardPrimary
    :action="createTenantTeam"
    header="Create new team"
  >
    <template v-slot:content>
      Create your own team for resource planning & skills analysis.
    </template>
  </ItemActionCardPrimary>
</template>

<script>
  import ItemActionCardPrimary from '@modules/card/item-action-card-primary'
  import { MODAL_WINDOW_NAMES } from '@js/constants'

  export default {
    name: 'TenantTeamCardAction',
    components: {
      ItemActionCardPrimary,
    },
    methods: {
      createTenantTeam: function () {
        this.$modal.show(MODAL_WINDOW_NAMES.CREATE_TENANT_TEAM_PRIMARY);
      },
    },
  };
</script>
